var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9876_96983)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M22.9344 0H9.06401C3.64161 0 0 3.80481 0 9.46721V22.5344C0 28.1952 3.64161 32 9.06401 32H22.9328C28.3552 32 32 28.1952 32 22.5344V9.46721C32 3.80481 28.3568 0 22.9344 0Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0859 14.9979H22.6859C23.2326 14.9979 23.6859 15.4512 23.6859 15.9979V18.4646C23.6859 19.0246 23.2326 19.4646 22.6859 19.4646C22.1259 19.4646 21.6859 19.0246 21.6859 18.4646V16.9979H19.9126V18.4646C19.9126 19.0246 19.4592 19.4646 18.9126 19.4646C18.3526 19.4646 17.9126 19.0246 17.9126 18.4646V16.9979H15.0859C14.6592 18.4246 13.3526 19.4646 11.7925 19.4646C9.8725 19.4646 8.3125 17.9179 8.3125 15.9979C8.3125 14.0912 9.8725 12.5312 11.7925 12.5312C13.3526 12.5312 14.6592 13.5712 15.0859 14.9979ZM10.3125 15.9979C10.3125 16.8112 10.9792 17.4646 11.7925 17.4646C12.5925 17.4646 13.2592 16.8112 13.2592 15.9979C13.2592 15.1846 12.5925 14.5312 11.7925 14.5312C10.9792 14.5312 10.3125 15.1846 10.3125 15.9979Z",
    fill: "#CE2600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9876_96983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.4711d734a85be8a283af62aab8a140d6.svg";
export { ForwardRef as ReactComponent };